import React, { useEffect, useState } from "react";
import PiFormQuestions from "../../../PIForm/Steps/step3/PiFormQuestions";
import { useGetDataForForm } from "../../../PIForm/Steps/hooks";
import { useFormInfo } from "../../../PIForm/Steps/hooks/useFormInfo";
import { useLanguage } from "../../../../hooks/useLanguage";
import { Wrapper } from "./styles";
import { useFormContext } from "react-hook-form";
import { PERSONAL_INFO_STEPS } from "../../../PIForm/Steps/step3/utils";
import NavButton from "../common/button";
import Loader from "../../../../shared/loaders/simpleLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTES } from "../constants";
import {
  getClientTypeIdFromOnboardingToken,
  onboardingPath,
  redirectToPiOnboardingIdentification,
} from "../helpers";
import useScrollToTop from "../../../../hooks/useScrollToTop";

const getInitialPerson = () => {
  try {
    return JSON.parse(localStorage.getItem("person") ?? "null");
  } catch {
    return null;
  }
};

function FormWrapper() {
  const [step, setStep] = useState(PERSONAL_INFO_STEPS.personDetails);

  const [person] = useState(getInitialPerson);

  const history = useHistory();
  const scrollToTop = useScrollToTop();

  const onboardingToken = sessionStorage.getItem("onboardingToken");

  if (!onboardingToken) {
    redirectToPiOnboardingIdentification();
  }

  const clientTypeId = getClientTypeIdFromOnboardingToken();
  const isPersonalDetails = step === PERSONAL_INFO_STEPS.personDetails;
  const isPepAndKyc = step === PERSONAL_INFO_STEPS.pepAndKyc;

  const { contentLanguage } = useLanguage();

  const { trigger, setValue } = useFormContext();

  const { isLoading, ...restData } = useGetDataForForm({
    locale: contentLanguage,
  });

  const { hasKycScore, ...otherFormInfo } = useFormInfo({ clientTypeId });

  const showPrevButton = isPepAndKyc;

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop, step]);

  async function handleNext() {
    const isValid = await trigger();
    if (isValid) {
      if (isPersonalDetails) {
        setStep(PERSONAL_INFO_STEPS.pepAndKyc);
        setValue("legalAddress", person?.legalAddress);
      }
      if (isPepAndKyc) {
        history.push(onboardingPath(ROUTES.aboutServices));
      }
    }
  }

  function handlePrev() {
    if (isPepAndKyc) {
      setStep(PERSONAL_INFO_STEPS.personDetails);
    }
  }

  if (isLoading) {
    return (
      <div style={{ marginTop: "32px" }}>
        <Loader />
      </div>
    );
  }
  return (
    <Wrapper>
      <PiFormQuestions
        data={{
          ...restData,
          ...otherFormInfo,
          person,
          isPersonalDetails,
          isPepAndKyc,
          hasKycScore: hasKycScore || person?.dualCitizenshipHighAmlRisk,
          isKeepz: true,
        }}
      />
      <NavButton
        showPrevButton={showPrevButton}
        handleNext={handleNext}
        handlePrev={handlePrev}
      />
    </Wrapper>
  );
}

export default FormWrapper;
